import { render, staticRenderFns } from "./RatingQuestion.vue?vue&type=template&id=fc49e304&scoped=true"
import script from "./RatingQuestion.vue?vue&type=script&lang=js"
export * from "./RatingQuestion.vue?vue&type=script&lang=js"
import style0 from "./RatingQuestion.vue?vue&type=style&index=0&id=fc49e304&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc49e304",
  null
  
)

export default component.exports